export const ADD_EDUCATION = 'ADD_EDUCATION';
export const ADD_LOCATION = 'ADD_LOCATION';
export const ADD_CAMPUS = 'ADD_CAMPUS';
export const ADD_TERMS = 'ADD_TERMS';
export const ADD_SCORE = 'ADD_SCORE';
export const SET_DEGREE_CHOICES = 'SET_DEGREE_CHOICES';
export const SET_DEGREE_CAREER_ID_MAP = 'SET_DEGREE_CAREER_ID_MAP';
export const SET_CAREER_TAB = 'SET_CAREER_TAB';
export const SHOW_PROGRESS_BAR = 'SHOW_PROGRESS_BAR';
export const SET_IMAGE_PAIRS = 'SET_IMAGE_PAIRS';
export const GET_DATA = 'GET_DATA';
export const EXISTING_USER_ID = 'EXISTING_USER_ID';
export const EXISTING_COGNITO_USERNAME = 'EXISTING_COGNITO_USERNAME';
export const GET_USER_DATA = 'GET_USER_DATA';
export const SAVE_USER_CHOICES = 'SAVE_USER_CHOICES';
export const SET_CAREER_DEGREE_MODALITY = 'SET_CAREER_DEGREE_MODALITY';
export const SET_CAREER_BRIGHT_OUTLOOK_MODALITY =
  'SET_CAREER_BRIGHT_OUTLOOK_MODALITY';

export const SET_USER = 'SET_USER';
export const SET_AUTH_STATUS = 'SET_AUTH_STATUS';
export const SET_ROGUE_TENANT_SSO = 'SET_ROGUE_TENANT_SSO';
export const ADMIN_REGISTER_NEW_USER = 'ADMIN_REGISTER_NEW_USER';
export const ADMIN_DELETE_USER = 'ADMIN_DELTE_USER';
export const USER_LOGOUT_AUTH = 'USER_LOGOUT_AUTH';
export const USER_LOGOUT_ONBOARDING = 'USER_LOGOUT_ONBOARDING';
export const USER_LOGOUT_ECAP = 'USER_LOGOUT_ECAP';
export const USER_LOGOUT_ADMIN = 'USER_LOGOUT_ADMIN';
export const USER_LOGOUT_PREREGISTRATION = 'USER_LOGOUT_PREREGISTRATION';
export const SET_FAVORITES = 'SET_FAVORITES';
export const UPDATE_USER_PHOTO_URL = 'UPDATE_USER_PHOTO_URL';
export const USER_PROFILE_PHOTO_FLAG = 'USER_PROFILE_PHOTO_FLAG';

export const SET_USERS_TAB_FILTERS = 'SET_USERS_TAB_FILTERS';
export const SET_USER_NAME_SEARCH_STRING = 'SET_USER_NAME_SEARCH_STRING';

export const GET_SKILLS = 'GET_SKILLS';
export const GET_SKILLS_COURSES = 'GET_SKILLS_COURSES';

export const GET_ALL_USERS = 'GET_ALL_USERS';
export const RESET_PAGES = 'RESET_PAGES';
export const GET_ADVISOR_USER_PROFILE = 'GET_ADVISOR_USER_PROFILE';

export const SET_ROLE_PERMISSIONS = 'SET_ROLE_PERMISSIONS';
export const DELETE_USER = 'DELETE_USER';
export const SET_USER_DB_INFO = 'SET_USER_DB_INFO';
export const SET_USER_GAME_INFO = 'SET_USER_GAME_INFO';

export const GET_TOP_MATCHES = 'GET_TOP_MATCHES';
export const GET_HIGH_SCHOOLS = 'GET_HIGH_SCHOOLS';
export const REGISTER_USER = 'REGISTER_USER';
export const SAVE_RESULTS = 'SAVE_RESULTS';

export const SET_LOADING = 'SET_LOADING';
export const SET_TENANT_CONFIG = 'SET_TENANT_CONFIG';
export const SET_TENANT_CAREERS = 'SET_TENANT_CAREERS';

export const SAVE_REGISTRATION_SOURCE = 'SAVE_REGISTRATION_SOURCE';

export const SET_ECAP = 'SET_ECAP';
export const SET_ECAP_CLASSES_MATCHED = 'SET_ECAP_CLASSES_MATCHED';
export const SET_ECAP_SUBJECT_DIFFICULTY = 'SET_ECAP_SUBJECT_DIFFICULTY';
export const SET_ACTION_PLAN = 'SET_ACTION_PLAN';
export const SET_COOKIES_CONSENT = 'SET_COOKIES_CONSENT';

export const SET_MODAL_IMAGE = 'SET_MODAL_IMAGE';
export const SET_ROGUE_USER = 'SET_ROGUE_USER';

export const SET_PRE_REGISTRATION_FLAG = 'SET_PRE_REGISTRATION_FLAG';
export const SET_REGISTER_OPTIONS = 'SET_REGISTER_OPTIONS';
export const REGISTRATION_COMPLETE = 'REGISTRATION_COMPLETE';
export const SET_REGISTRATION_IN_PROGRESS = 'SET_REGISTRATION_IN_PROGRESS';

export const SET_CURRENT_LOCALE = 'SET_CURRENT_LOCALE';
